import { Search } from "lucide-react";
import { Input } from "../../../../components/ui/common/input";
import { FacilityListToolbarProps } from "../types/facilityList.types";
import { FacilityTypeFilterPanel } from "./FacilityTypeFilterPanel";

export const FacilityListToolbar = ({ register, refetchWithFilters }: FacilityListToolbarProps) => (
  <div className="tw-mb-4 tw-flex tw-flex-col tw-gap-3 sm:tw-flex-row sm:tw-items-center">
    <div className="tw-relative tw-w-full sm:tw-w-72">
      <Search
        size={16}
        className="tw-pointer-events-none tw-absolute tw-left-3 tw-top-1/2 -tw-translate-y-1/2 tw-text-muted-foreground"
      />
      <Input
        {...register("searchFacility")}
        placeholder="Search facility, type, city"
        className="tw-pl-9"
      />
    </div>
    <FacilityTypeFilterPanel refetchWithFilters={refetchWithFilters} />
  </div>
);
